import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { CompanyService } from '@s-services/company.service';
import { ResourceService } from '@s-services/resource.service';
import { AuthService } from '@s-services/auth.service';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Resource, User } from '@semmily/types';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@s-app/material.module';

@Component({
    selector: 'app-list-resources-as-bookingprofiles',
    templateUrl: './list-resources-as-bookingprofiles.component.html',
    styleUrls: ['./list-resources-as-bookingprofiles.component.scss'],
    imports: [
        CommonModule,
        FormsModule,
        MaterialModule
    ]
})
export class ListResourcesAsBookingprofilesComponent implements OnInit, OnDestroy {
  @Output() handleResourceClick = new EventEmitter();
  @Output() handleCategoryClick = new EventEmitter();

  private destroy$ = new Subject<void>();
  resourcesInCalendar: string[] = [];
  resources$: Observable<Resource[]>;

  constructor(
    public companyService: CompanyService,
    private resourceService: ResourceService,
    private authService: AuthService
  ) {
    this.resources$ = this.resourceService.companyResources.pipe(map((resources: Resource[]) => resources.filter(r => !r.parentId)));
  }

  ngOnInit() {
    this.authService.user.pipe(takeUntil(this.destroy$)).subscribe((user: User | null) => {
      this.resourcesInCalendar = user?.resourcesInCalendar || [];
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isResourceChecked(bpId: string) {
    return this.resourcesInCalendar ? this.resourcesInCalendar.indexOf(bpId) >= 0 : false;
  }

  filterCategories(resources: Resource[]) {
    return resources
      .filter(r => r.categories && r.categories.length)
      .map(r => r.categories!).reduce((acc: string[], cur: string[]) => acc = Array.from(new Set(acc.concat(cur))), []);
  }



}
